/* eslint-disable @angular-eslint/directive-class-suffix */
/* eslint-disable @angular-eslint/no-host-metadata-property */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { Directive } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ValueAccessor } from './value.accessor';

const BOOLEAN_VALUE_SELECTOR_LIST = `
  dcr-checkbox[formControl],
  dcr-checkbox[formControlName],
  dcr-checkbox[ngModel],
  dcr-switch[formControl],
  dcr-switch[formControlName],
  dcr-switch[ngModel]
`;

@Directive({
  /* tslint:disable-next-line:directive-selector */
  selector: BOOLEAN_VALUE_SELECTOR_LIST,
  host: {
    '(change)': 'handleChangeEvent($event.target.checked)',
  },
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: BooleanValueAccessor,
      multi: true,
    },
  ],
  standalone: false,
})
export class BooleanValueAccessor extends ValueAccessor {
  override writeValue(value: boolean) {
    if (this.lastValue !== value) {
      this._element.nativeElement.checked = this.lastValue = value == null ? '' : value;
    }
  }
}
